import React from "react";
import { ISearchField, ISearchProp } from "../Types";
import { DatePicker } from "antd";
import moment from "moment";

type PropType = ISearchProp & ISearchField

const { RangePicker } = DatePicker;
export const SearchRangePicker = ({ searchValues, rangePickerFieldName, timeIsT, ...props }: PropType) => {

    const fieldName = rangePickerFieldName ?? ["startTime", "endTime"];
    const isT = timeIsT ?? false

    const handleStrLength = (str: string): boolean => {
        if (!str) return false;
        return str.length > 10 ? false : true;
    }

    return <RangePicker
        showTime={props.showTime}
        placeholder={props.placeholder as [string, string]}
        className="ant-picker-round"
        format={props.format || "YYYY-MM-DD HH:mm:ss"}
        value={
            !searchValues?.[fieldName[0]] || !searchValues?.[fieldName[1]] || handleStrLength(searchValues?.[fieldName[0]] as string) ?
                null :
                [moment(searchValues?.[fieldName[0]]), moment(searchValues?.[fieldName[1]])]
        }
        onChange={(value, timeStr) => {
            let obj = {
                [fieldName[0]]: props.format ? timeStr[0].length === 10 ? timeStr[0] + (isT ? 'T00:00:00' : ' 00:00:00') : "" : timeStr[0],
                [fieldName[1]]: props.format ? timeStr[1].length === 10 ? timeStr[1] + (isT ? 'T23:59:59' : ' 23:59:59') : "" : timeStr[1]
            }
            props.onChange?.(obj);
            if (props.triggerSearch) props.handleSearch?.(obj);
        }}
        disabled={props.disabled} />;
}